import ModuleCenter from "../datamodule/ModuleCenter";
import { useTokenStore } from "../store/TokenStore";

const saveRecord = async (resource, operationType, operationResult, delFlag)=> {
    const token = useTokenStore();
    const recordModule = ModuleCenter.getModule('resourceCheckLog');
    const data = {operatorId:token.userid, resourceId:delFlag ? null : resource.id, tags:delFlag ? resource.id : null, memo:resource.name, operationType, operationResult};
    await recordModule.createData(data);
}
const saveRecords = async (resources, operationType, operationResult, delFlag)=> {
    const token = useTokenStore();
    const recordModule = ModuleCenter.getModule('resourceCheckLog');
    const datas = resources.map((resource)=> {
        return {operatorId:token.userid, resourceId:delFlag ? null : resource.id, tags:delFlag ? resource.id : null, mome:resource.name, operationType, operationResult};
    })
    await recordModule.createDatas(datas);
}

export default function saveResourceRecord(resource, operationType, operationResult, delFlag) {
    if (!resource) return;
    if (resource instanceof Array) {
        saveRecords(resource, operationType, operationResult, delFlag);
    } else {
        saveRecord(resource, operationType, operationResult, delFlag)
    }
}